import { initialReducerState } from '../constants/index'
import { useRef } from 'react'

const getRap = ({ minValue = 0, maxValue = 100, step = 1 }) => {
  return Array(Math.ceil((maxValue - minValue) / step) + 1).fill(minValue).map((x, y) => x + y * step)
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'color':
      return { ...state, color: action.payload }
    case 'clarity':
      return { ...state, clarity: action.payload }
    case 'shape':
      return { ...state, shape: action.payload }
    case 'rap':
      return { ...state, rap: action.payload }
    case 'carat':
      return { ...state, carat: handleCaratValue(state, action.payload) }
    case 'price':
      return { ...state, price: action.payload }
    case 'priceTotal':
      return { ...state, priceTotal: action.payload }
    case 'priceInitial':
      return { ...state, priceInitial: action.payload }
    case 'priceTotalInitial':
      return { ...state, priceTotalInitial: action.payload }
    case 'activeInputName':
      return { ...state, activeInputName: action.payload }
    case 'resetAllInputs':
      return { ...state, price: '0', priceTotal: '0', priceInitial: '0', priceTotalInitial: '0', carat: '' }
    default:
      return { initialReducerState }
  }
}

const useMultiplyRefs = (swiperLength) => {
  return new Array(swiperLength).fill({}).map(() => useRef(null))
}

const getSetByProp = (data, sector) => {
  return [...new Set(data.map(item => item[sector]))]
}

const getSelectOptions = (data, isInitialTabs = false) => {
  if (isInitialTabs) {
    return data.map((item) => {
      return {
        ...item,
        label: item.name,
        value: item.name
      }
    })
  }
  return data.map((item) => {
    return {
      label: item,
      value: item
    }
  })
}

const handleCaratValue = (state, carat) => {
  if (carat && (parseFloat(carat.replace(',', '.')) > 999)) return state.carat
  return carat
}

export {
  getRap,
  reducer,
  useMultiplyRefs,
  getSetByProp,
  getSelectOptions
}
